import React from "react";

interface LoadingOverlayProps {
    show: boolean;
    text?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ show, text }) => {
    if (!show) return null;
    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center">
            {/* Glassy feathered background using Tailwind and radial gradient */}
            <div className="absolute inset-0 pointer-events-none" style={{
                background: "radial-gradient(circle at center, rgba(30,41,59,0.85) 60%, rgba(30,41,59,0.6) 80%, rgba(30,41,59,0.2) 100%)",
                backdropFilter: "blur(24px)",
                WebkitBackdropFilter: "blur(24px)",
            }} />
            {/* Canvas placeholder (optional, not visible unless drawn on) */}
            <canvas id="loading-canvas" className="absolute inset-0 w-full h-full pointer-events-none" />
            <div className="relative flex flex-col items-center justify-center p-8 rounded-2xl shadow-2xl bg-slate-900/80 border border-white/10 backdrop-blur-xl" style={{
                boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
            }}>
                <div className="mb-6">
                    <svg className="animate-spin h-16 w-16 text-ecpi-blue" viewBox="0 0 50 50">
                        <circle className="opacity-20" cx="25" cy="25" r="20" stroke="currentColor" strokeWidth="6" fill="none" />
                        <circle className="opacity-80" cx="25" cy="25" r="20" stroke="currentColor" strokeWidth="6" fill="none" strokeDasharray="31.4 94.2" strokeLinecap="round" />
                    </svg>
                </div>
                <h2 className="text-2xl font-bold text-white mb-2 text-center">{text || "Loading..."}</h2>
                <p className="text-slate-300 text-center max-w-xs mb-2">Please wait while the page loads.</p>
            </div>
        </div>
    );
};

export default LoadingOverlay;
